// 吃瓜大赛 S07 赛季 · 静态展示数据
// 本站为娱乐向内容栏目，所有登场瓜位、选手代号与剧情均为虚构演绎。

export type ToneKey = 'primary' | 'accent' | 'secondary' | 'cream';

export interface FeedItem {
  tag: string;
  tagTone: ToneKey;
  time: string;
  text: string;
}

// 顶部实时动态速递
export const liveTicker: FeedItem[] = [
  { tag: '半决赛', tagTone: 'primary', time: '今日 18:42', text: '半决赛第 2 场对阵名单锁定：月半瓜 迎战 滚圆球球，今晚 20:00 正式开打。' },
  { tag: '战报', tagTone: 'accent', time: '今日 15:20', text: '8 强战报更新：黑籽侦探 与 瓜小满 分列上下半区头名，双双锁定半决赛席位。' },
  { tag: '榜单', tagTone: 'secondary', time: '今日 12:05', text: '实时投票支持率出炉，月半瓜 以 71% 的支持率暂居本赛季热度榜首。' },
  { tag: '赛程', tagTone: 'primary', time: '今日 09:30', text: '决赛之夜定档 9 月 12 日，总决赛将采用三局两胜制决出赛季瓜王。' },
  { tag: '动态', tagTone: 'accent', time: '昨日 22:10', text: '观众竞猜通道开启，猜中半决赛胜者即可瓜分本期瓜田彩蛋。' },
  { tag: '规则', tagTone: 'secondary', time: '昨日 20:00', text: '今晚 20:00 半决赛投票通道将在开赛后 30 分钟关闭，记得准时投票。' },
  { tag: '战报', tagTone: 'accent', time: '9-05', text: '8 强下半区战罢：连瓤侠 逆转晋级，成为本赛季首位从死亡小组突围的瓜位。' },
  { tag: '前瞻', tagTone: 'primary', time: '9-03', text: '8 强焦点战前瞻：白皮刺客 与 黑籽侦探 的舆论交锋成为全场最大看点。' },
];

export interface ScheduleItem {
  round: string;
  day: string;
  time: string;
  title: string;
  status: 'result' | 'live' | 'upcoming';
  note: string;
}

// 赛程安排（按轮次分页）
export const scheduleRounds = [
  { key: 'seeding', name: '小组海选' },
  { key: 'r16', name: '16 强' },
  { key: 'r8', name: '8 强' },
  { key: 'sf', name: '半决赛' },
  { key: 'final', name: '决赛' },
];

export const scheduleData: Record<string, ScheduleItem[]> = {
  seeding: [
    { round: 'A 组', day: '08-24', time: '20:00', title: '瓜小满 · 爆汁龙 · 藤上小青 · 白皮刺客 混战晋级', status: 'result', note: '瓜小满 以 79% 支持率领跑出线' },
    { round: 'B 组', day: '08-25', time: '20:00', title: '半沙老甘 · 籽里巴特 · 月半瓜 · 瓤心甜豆 混战晋级', status: 'result', note: '月半瓜 黑马姿态拿下 B 组头名' },
    { round: 'C 组', day: '08-26', time: '20:00', title: '脆皮阿肆 · 黑籽侦探 · 蜜渡桃 · 连瓤侠 混战晋级', status: 'result', note: '黑籽侦探 全程领跑，未失一局' },
    { round: 'D 组', day: '08-27', time: '20:00', title: '滚圆球球 · 切开有光 · 沙地瓜农 · 月光半熟 混战晋级', status: 'result', note: '滚圆球球 后半程发力反超晋级' },
  ],
  r16: [
    { round: '上半区', day: '08-29', time: '20:00', title: '瓜小满 VS 藤上小青', status: 'result', note: '瓜小满 晋级，胜率 68%' },
    { round: '上半区', day: '08-29', time: '21:30', title: '爆汁龙 VS 白皮刺客', status: 'result', note: '爆汁龙 逆转晋级，白皮刺客 遗憾止步' },
    { round: '下半区', day: '08-30', time: '20:00', title: '黑籽侦探 VS 蜜渡桃', status: 'result', note: '黑籽侦探 轻取晋级' },
    { round: '下半区', day: '08-30', time: '21:30', title: '滚圆球球 VS 切开有光', status: 'result', note: '滚圆球球 加时险胜晋级' },
  ],
  r8: [
    { round: '上半区', day: '09-01', time: '20:00', title: '瓜小满 VS 爆汁龙', status: 'result', note: '瓜小满 2:0 挺进半决赛' },
    { round: '上半区', day: '09-01', time: '21:30', title: '半沙老甘 VS 月半瓜', status: 'result', note: '月半瓜 2:1 险胜晋级半决赛' },
    { round: '下半区', day: '09-02', time: '20:00', title: '黑籽侦探 VS 籽里巴特', status: 'result', note: '黑籽侦探 强势晋级半决赛' },
    { round: '下半区', day: '09-02', time: '21:30', title: '连瓤侠 VS 滚圆球球', status: 'result', note: '滚圆球球 逆转晋级半决赛' },
  ],
  sf: [
    { round: '半决赛 1', day: '09-07', time: '20:00', title: '瓜小满 VS 月半瓜', status: 'live', note: '今晚焦点战 · 上半区席位之争' },
    { round: '半决赛 2', day: '09-07', time: '21:40', title: '黑籽侦探 VS 滚圆球球', status: 'upcoming', note: '紧随其后开打 · 下半区席位之争' },
    { round: '总决赛', day: '09-12', time: '20:00', title: '半决赛胜者会师决赛', status: 'upcoming', note: '三局两胜制 · 决出赛季瓜王' },
  ],
  final: [
    { round: '总决赛之夜', day: '09-12', time: '20:00', title: '上半区瓜王候选 VS 下半区瓜王候选', status: 'upcoming', note: '三局两胜 · 问鼎 S07 赛季瓜王' },
    { round: '颁奖盛典', day: '09-12', time: '21:30', title: '赛季瓜王加冕 + 全场最甜奖', status: 'upcoming', note: '现场揭晓瓜田彩蛋大奖' },
  ],
};

export interface ReportItem {
  tag: string;
  tone: ToneKey;
  title: string;
  excerpt: string;
  points: string[];
  view: string;
  date: string;
}

// 晋级战报瀑布流
export const reports: ReportItem[] = [
  {
    tag: '8 强战报', tone: 'primary', date: '09-02',
    title: '滚圆球球连扳两局，强势锁定最后一张半决赛门票',
    excerpt: '8 强收官战上演反转好戏。前半段处于劣势的滚圆球球在下半场连续抢下关键票数，最终以 2:1 逆转连瓤侠，压哨搭上半决赛末班车。',
    points: ['首局连瓤侠稳扎稳打先声夺人', '次局滚圆球球针对性发力扳回一城', '决胜局支持率一度胶着，滚圆球球末段爆发取胜'],
    view: '3.8 万热度',
  },
  {
    tag: '8 强战报', tone: 'accent', date: '09-01',
    title: '月半瓜决胜局逆转半沙老甘，成上半区最大黑马',
    excerpt: '不被看好的月半瓜在决胜局顶住压力，以细腻的“梗点”表达力完成逆转。从小组赛一路走来，月半瓜已成为本赛季最稳定的“话题增长点”。',
    points: ['前两局双方各下一城战成平手', '决胜局月半瓜抓住时机打出一波舆论高潮', '赛后实时热度跃居本赛季榜首'],
    view: '2.9 万热度',
  },
  {
    tag: '焦点前瞻', tone: 'secondary', date: '09-03',
    title: '白皮刺客出局引热议：8 强阶段的“上限之争”复盘',
    excerpt: '作为赛前公认的技术型瓜位，白皮刺客止步 16 强让不少追更党直呼意外。本文从舆论节奏、话题密度与破圈能力三个维度复盘其出局原因。',
    points: ['话题上限虽高，但“保温”能力不足', '关键局支持率波动明显，缺乏稳定基本盘', '为后续赛段的节奏把控提供参考样本'],
    view: '1.2 万热度',
  },
  {
    tag: '小组综述', tone: 'primary', date: '08-27',
    title: '小组海选收官：16 席瓜位出炉，四组头名各具风格',
    excerpt: '为期四天的小组海选全部结束，16 位候选瓜位正式亮相。瓜小满稳如磐石、月半瓜强势出圈、黑籽侦探全程领跑、滚圆球球后半程发力，四组头名风格迥异。',
    points: ['A 组瓜小满一路领跑未给对手机会', 'B 组月半瓜黑马成色十足', 'C/D 组冠军种子均顺利过关'],
    view: '6.1 万热度',
  },
];

export interface BracketNode {
  name: string;
  tone: ToneKey;
  ratio: number;
}

export interface BracketGroup {
  title: string;
  desc: string;
  slots: BracketNode[];
}

// 晋级墙（当前赛季晋级情况）
export const bracketGroups: BracketGroup[] = [
  {
    title: '上半区 · 四强瓜位',
    desc: '上半区淘汰赛于今晚 20:00 收束，胜者直通总决赛',
    slots: [
      { name: '瓜小满', tone: 'primary', ratio: 78 },
      { name: '月半瓜', tone: 'secondary', ratio: 71 },
    ],
  },
  {
    title: '下半区 · 四强瓜位',
    desc: '下半区半决赛紧随其后，争夺另一个决赛名额',
    slots: [
      { name: '黑籽侦探', tone: 'accent', ratio: 74 },
      { name: '滚圆球球', tone: 'primary', ratio: 66 },
    ],
  },
];

export const stagePills = ['海选 16 席', '16 强晋级', '8 强晋级', '4 强晋级', '决赛 2 席'];

export const championSeeds = ['瓜小满', '月半瓜', '黑籽侦探', '滚圆球球'];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '吃瓜大赛的晋级规则是怎样的？',
    a: '每期 16 个候选瓜位分组对抗，由观众投票决出胜负，得票高者晋级下一轮，依次经过 16 强、8 强、4 强，直至决出当期赛季瓜王。投票越多，你支持的瓜位走得更远。',
  },
  {
    q: '在哪里可以看到最新赛程与晋级名单？',
    a: '本站首页顶部即可查看当前进行到的轮次与下一场对决时间，赛程安排和实时动态板块持续更新，晋级名单也会随每一轮战果同步刷新，点开即知谁已晋级。',
  },
  {
    q: '赛程和战报多久更新一次？',
    a: '每场比赛结束后的第一时间发布晋级战报，赛前 30 分钟更新对阵时间与参赛席位；实时动态板块会对关键节点做逐条速递，重要节点绝不错过。',
  },
  {
    q: '选手与话题是真实事件吗？',
    a: '本站为娱乐向内容栏目，所有登场瓜位、选手代号与剧情均为虚构演绎，仅供休闲追更娱乐，请勿与现实人物或事件对号入座。',
  },
];

export interface AboutPoint {
  icon: string;
  title: string;
  desc: string;
  tone: ToneKey;
}

export const aboutPoints: AboutPoint[] = [
  { icon: 'ri-heart-3-line', title: '有梗不硬拗', desc: '每期瓜位都以真实舆论逻辑为骨架打磨，追更起来自然顺畅，不靠生硬噱头博眼球。', tone: 'primary' },
  { icon: 'ri-flashlight-line', title: '更新不停更', desc: '赛程、战报、实时动态全部按时更新，关键节点逐条速递，重要轮次绝不错过。', tone: 'accent' },
  { icon: 'ri-bar-chart-2-line', title: '数据看得见', desc: '支持率、热度、晋级走向全部可视化呈现，追更体验像在看一场真正的晋级赛。', tone: 'secondary' },
];

export const editorialRules = [
  '所有瓜位与剧情均为虚构演绎，仅供娱乐，不对号入座',
  '不搬运未经核实的信息，不做哗众取宠的标题党',
  '投票与晋级数据全程透明，战报内容可回溯可复核',
];